import Button from "components/base/Button";
import Tag from "components/base/Tag";
import { useModals } from "ModalProvider";
import ObjectTagsManager from "./ObjectTagsManager";

const ObjectTagsView = ({
  tags,
  contentTypeAppLabel,
  contentTypeName,
  objectId,
}) => {
  const modal = useModals();

  function editHandler() {
    modal.present({
      title: "Manage Tags",
      children: (
        <ObjectTagsManager
          initialTags={tags}
          contentTypeAppLabel={contentTypeAppLabel}
          contentTypeName={contentTypeName}
          objectId={objectId}
          hide={modal.hide}
        />
      ),
    });
  }

  return (
    <div className="card">
      <div className="flex items-center justify-between">
        <h5>tags</h5>
        <Button onClick={editHandler}>Edit</Button>
      </div>
      <div className="mt-2">
        {tags.length > 0 ? (
          <div className="flex flex-wrap gap-2 -mx-[2px]">
            {tags.map((tag) => (
              <Tag key={tag.id} value={tag.label} />
            ))}
          </div>
        ) : (
          <div className="text-gray-500 text-sm">No tags assigned.</div>
        )}
      </div>
    </div>
  );
};

export default ObjectTagsView;
